import React, {useState} from 'react';
import { Construction, Clock, Mail } from 'lucide-react';
import ContactButton from '../../components/Navbar/contact-button';


const MaintenancePage = () => {

    const [showContactButton, setShowContactButton] = useState(false);

  const handleContactClick = () => {
    setShowContactButton(true);
  };
  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow border-0">
              <div className="card-body text-center p-5">
                
                {/* Icon */}
                <div className="mb-4">
                  <Construction size={64} className="text-warning" />
                </div>

                {/* Title */}
                <h1 className="h2 fw-bold text-dark mb-3">
                  Under Maintenance
                </h1>

                {/* Description */}
                <p className="text-muted mb-4">
                  We're currently performing scheduled maintenance. 
                  We'll be back online shortly.
                </p>

                {/* Time info */}
                {/* <div className="d-flex align-items-center justify-content-center text-muted mb-4">
                  <Clock size={16} className="me-2" />
                  <small>Expected downtime: 30 minutes</small>
                </div> */}

                {/* Contact */}
                <div className="mt-4">
                  <p className="small text-muted mb-2">Need help?</p>
                  {!showContactButton ? (
                  <button 
                     onClick={handleContactClick}
                     className="btn btn-outline-primary btn-sm d-inline-flex align-items-center">
                    <Mail size={16} className="me-2" />
                    Contact Support
                  </button>
                  ):(
                       <div className="mt-3 btn  btn-sm d-inline-flex align-items-center">
                      <ContactButton />
                    </div>
                  )
                }
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;